import React from "react";

import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactjs from "../assets/react.png";
import github from "../assets/github.png";
import tailwind from "../assets/tailwind.png";
import php from "../assets/php.png";
import symfony from "../assets/symfony.svg";
import postgresql from "../assets/postgresql.png";
import java from "../assets/java.png";
import python from "../assets/python.png";
import prestashop from "../assets/prestashop.png";
import vuejs from "../assets/vuejs.png";

const Technologies = () => {
  const technologies = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: python,
      title: "Python",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: php,
      title: "PHP",
      style: "shadow-indigo-500",
    },
    {
      id: 5,
      src: javascript,
      title: "Javascript",
      style: "shadow-yellow-500",
    },
    {
      id: 6,
      src: java,
      title: "Java",
      style: "shadow-red-500",
    },
    {
      id: 7,
      src: reactjs,
      title: "ReactJS",
      style: "shadow-blue-600",
    },
    {
      id: 8,
      src: symfony,
      title: "Symfony",
      style: "shadow-zinc-900",
    },

    {
      id: 9,
      src: github,
      title: "Github",
      style: "shadow-gray-400",
    },
    {
      id: 10,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 11,
      src: postgresql,
      title: "Postgresql",
      style: "shadow-blue-400",
    },
    {
      id: 12,
      src: prestashop,
      title: "Prestashop",
      style: "shadow-blue-200",
    },
    {
      id: 13,
      src: vuejs,
      title: "Vue",
      style: "shadow-green-400",
    },
  ];

  return (
    <div
      name="technologies"
      className="bg-gradient-to-b sm:pb-60 from-black to-gray-800 w-full h-fit"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border- gray-500 p-2 inline">
            Technologies
          </p>
          <p className="py-6">
            Un aperçu des outils, langages et frameworks que j’ai appris à
            maîtriser au fil de mes projets, en formation et en entreprise.
          </p>
        </div>

        <div className=" w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 text-center py-8 px-12 sm:px-0 ">
          {technologies.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Technologies;
